var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 144,
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 144,
    height: 144,
    rx: 72,
    fill: "#EB5757"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3104_65745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.125 50.5232L79.6555 71.9932L101.125 93.4631L93.9688 100.62L72.4989 79.1498L51.0289 100.62L43.8723 93.4631L65.3422 71.9932L43.8723 50.5232L51.0289 43.3666L72.4989 64.8365L93.9688 43.3666L101.125 50.5232Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3104_65745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white",
    transform: "translate(26.5 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckClose);
export default __webpack_public_path__ + "static/media/check-close.f7dec39d5318d50f8605ade87caf9728.svg";
export { ForwardRef as ReactComponent };